import { Link } from "react-router-dom";
import logo from "@/assets/bimbee-logo.webp";

const footerLinks = {
  מוצרים: [
    { label: "RevKit", path: "/revkit" },
    { label: "Listools", path: "/listools" },
    { label: "RapidRebar", path: "/rapidrebar" },
  ],
  חברה: [
    { label: "דף הבית", path: "/" },
    { label: "אודות ויצירת קשר", path: "/about" },
  ],
  משפטי: [
    { label: "תנאי שימוש", path: "/terms" },
    { label: "מדיניות פרטיות", path: "/privacy" },
    { label: "מדיניות ביטולים", path: "/cancellation" },
    { label: "הצהרת נגישות", path: "/accessibility" },
  ],
};

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-border">
      <img src="/images/footer-bg-new.png" alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/40" />
      <div className="container relative z-10 py-20 md:py-24 [text-shadow:_1px_1px_4px_rgba(0,0,0,0.6)]">
        <div className="grid grid-cols-2 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="mb-3 text-base font-semibold text-white">{title}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm md:text-base text-white/80 transition-colors hover:text-white">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Brand */}
          <div className="text-left col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 justify-start">
              <img src={logo} alt="Bimbee" className="h-8 w-8" />
              <span className="text-lg font-bold text-white">Bimbee</span>
            </Link>
            <p className="text-base text-white/80 leading-relaxed">
              כלי פרודוקטיביות מתקדמים לאנשי BIM ו-Revit
            </p>
            <p className="mt-3 text-base text-white/80">
              office@bimbee.net
            </p>
          </div>
        </div>

        <div className="mt-10 border-t border-white/20 pt-6 text-center text-sm text-white/80 space-y-2">
          <p>© {new Date().getFullYear()} Bimbee. כל הזכויות שמורות.</p>
          <p>
            Made with ✨ by{" "}
            <a href="https://www.moonagency.ai" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">
              Moon Agency
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
